<!--
   Created by qing on 2020/2/27 3:46 下午
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__grade" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <van-rate
          :readonly="isReadOnly || isRead"
          v-model="currentRow[current.dataId]"
          :size="20"
          :count="current.maxValue"
          :void-color="current.uncheckColor"
          :allow-half="!!current.halfChoose"
          :color="current.setupColor ? current.selectColors[2] : '#F7BA2A'"
          void-icon="star"
          @change="controlChange">
        </van-rate>
        <div v-if="current.assistTexts.length && currentRow[current.dataId] > 0">
          {{current.assistTexts[Math.ceil(currentRow[current.dataId]) - 1]}}
        </div>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__grade-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            <van-rate
              :readonly="isReadOnly || isRead"
              v-model="currentRow[current.dataId]"
              :size="20"
              :count="current.maxValue"
              :void-color="current.uncheckColor"
              :allow-half="!!current.halfChoose"
              :color="current.setupColor ? current.selectColors[2] : '#F7BA2A'"
              void-icon="star"
              @change="controlChange">
            </van-rate>
            <div v-if="current.assistTexts.length && currentRow[current.dataId] > 0">
              {{current.assistTexts[Math.ceil(currentRow[current.dataId]) - 1]}}
            </div>
          </div>
        </template>
      </van-field>
    </div>
  </div>

</template>

<script>
  import { current } from './mixin'

  export default {
    mixins: [current]
  }
</script>